import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'
import ReactToPrint from 'react-to-print'
import { taskOperationsService } from '../../../_services/taskOperations.service'
import moment from 'moment-jalaali'
import Loading from '../../Shared/Loading'

import { MdPrint } from 'react-icons/md'
import { AiOutlineLoading } from 'react-icons/ai'
// import { el } from 'date-fns/locale'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />
})

const Print = props => {
  const [loading, setLoading] = useState(false)
  const [showDialog, setShowDialog] = useState(false)
  const [taskOperationsId, setTaskOperationsId] = useState(
    props.taskOperationsId
  )
  const [data, setData] = useState(undefined)

  const printSection = useRef()

  useEffect(() => {
    setData(undefined)

    setShowDialog(props.show)

    setTaskOperationsId(props.taskOperationsId)

    getData()
  }, [props.taskOperationsId])

  const getData = () => {
    setLoading(true)

    taskOperationsService
      .GetByIdHistory(props.taskOperationsId)
      .then(ress => {
        let res = ress.data

        // res["lastDescription"] = res.description;
        // res["description"] = '';

        // if (res.items) {

        //   let outputs = []
        //   res.items.forEach(item => {
        //     item["extraQuantity"] = 0;
        //     item["subExtraQuantity"] = 0;
        //     item["firstQuantity"] = item.quantity;
        //     if (item.taskOperationProductType === 1) {
        //       outputs.push(item)
        //     }
        //   });

        //   res["items"] = res.items.filter(el => parseInt(el.taskOperationProductType, 0) === 0);
        //   res["outputs"] = outputs;

        // }

        console.log(res)
        setData(res)
        setLoading(false)
      })
      .catch(error => {
        // console.log(error);
        setLoading(false)
      })
  }

  const handleCloseDialog = () => {
    setShowDialog(false)

    props.onClose()
  }

  const handlePrint = () => {
    setLoading(false)

    props.onClose()
  }

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth="md"
        className="message-dialog"
        open={props.show}
        TransitionComponent={Transition}
        onClose={() => handleCloseDialog()}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description">
        <DialogContent className="inquiry-result-container">
          <ReactToPrint
            onAfterPrint={() => handlePrint()}
            trigger={() => (
              <div style={{ width: '100%', textAlign: 'center' }}>
                <a
                  className="btn btn-block btn-primary"
                  onClick={() => setLoading(true)}>
                  {loading ? (
                    <AiOutlineLoading
                      className="mdi-spin"
                      size="32px"
                      style={{ marginLeft: 10 }}
                    />
                  ) : (
                    <MdPrint
                      size="32px"
                      style={{ verticalAlign: 'middle', marginLeft: 10 }}
                    />
                  )}
                  چاپ
                </a>
              </div>
            )}
            content={() => printSection.current}
          />

          <page className="A4" ref={printSection}>
            <section class="sheet padding-3mm">
              {data && (
                <div className="print">
                  <div className="row">
                    <div className="task-info">
                      <div className="info">
                        <div className="right">
                          <div className="date">
                            <div className="date-title">
                              <strong>تاریخ ثبت سفارش تولید:</strong>
                            </div>
                            <div className="date-date">
                              {moment(
                                data.task.createdAt,
                                'YYYY/M/D H:m'
                              ).format('jYYYY/jM/jD')}
                            </div>
                          </div>
                          <div className="date">
                            <div className="date-title">
                              <strong>تاریخ پرینت:</strong>
                            </div>
                            <div className="date-date">
                              {moment(data.printedAt, 'YYYY/M/D H:m').format(
                                'jYYYY/jM/jD'
                              )}
                            </div>
                          </div>
                          <div className="date">
                            <div className="date-title">
                              <strong>ساعت پرینت:</strong>
                            </div>
                            <div className="date-date">
                              {moment(data.printedAt, 'YYYY/M/D H:m').format(
                                'H:mm'
                              )}
                            </div>
                          </div>
                          <div className="date">
                            <div className="date-title">
                              <strong>شماره پرس:</strong>
                            </div>
                            <div className="date-date">
                              {data.unit && data.unit.name}
                            </div>
                          </div>
                        </div>
                        <div className="code">#{data.task.taskCode}</div>
                      </div>
                      <div className="logo">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.0"
                          viewBox="0 0 1103.000000 915.000000"
                          preserveAspectRatio="xMidYMid meet">
                          <g
                            transform="translate(0.000000,915.000000) scale(0.100000,-0.100000)"
                            fill="#000000"
                            stroke="none">
                            <path d="M550 5045 l0 -3685 225 0 225 0 0 3455 0 3455 2275 0 2275 0 0 -1520 0 -1520 220 0 220 0 0 1750 0 1750 -2720 0 -2720 0 0 -3685z" />
                            <path d="M4500 4951 c-80 -11 -152 -38 -202 -73 -50 -37 -61 -49 -89 -102 -30 -57 -25 -187 10 -238 56 -81 157 -112 411 -127 91 -6 188 -17 215 -25 70 -21 116 -70 122 -130 10 -85 -37 -146 -144 -186 -52 -20 -71 -22 -178 -17 -138 6 -230 31 -354 98 -40 22 -75 38 -76 37 -1 -2 -18 -31 -38 -65 l-36 -63 52 -30 c108 -62 244 -104 399 -122 226 -27 419 41 503 176 26 43 30 60 34 138 3 80 0 94 -24 143 -60 123 -208 184 -450 185 -115 0 -215 14 -256 36 -38 19 -62 67 -54 105 17 74 112 121 248 121 107 0 200 -23 314 -78 51 -24 94 -44 96 -44 6 0 79 122 75 125 -16 14 -125 68 -168 84 -124 46 -297 68 -410 52z" />
                            <path d="M3264 4931 c-264 -42 -426 -233 -425 -504 0 -242 137 -423 366 -483 61 -17 225 -18 297 -3 161 35 285 141 349 301 27 66 37 227 20 310 -35 167 -162 307 -327 358 -73 22 -207 32 -280 21z m244 -155 c245 -88 311 -432 118 -614 -73 -70 -144 -95 -266 -95 -132 0 -194 24 -277 108 -51 52 -65 73 -82 130 -67 214 37 423 239 480 66 18 204 14 268 -9z" />
                            <path d="M1420 4430 l0 -501 78 3 77 3 5 351 5 351 185 -268 c102 -148 187 -269 190 -269 3 1 88 122 190 269 l185 269 3 -354 2 -354 80 0 80 0 0 500 0 500 -67 0 -68 -1 -195 -280 c-107 -154 -199 -284 -205 -288 -6 -5 -88 104 -210 280 l-200 288 -67 1 -68 0 0 -500z" />
                            <path d="M6358 4813 c60 -65 168 -181 240 -258 l131 -140 1 -242 0 -243 75 0 75 0 0 270 0 269 -212 230 -213 231 -104 0 -103 0 110 -117z" />
                            <path d="M6636 4918 c5 -7 89 -103 188 -212 100 -110 196 -216 214 -237 l32 -37 0 -251 0 -251 75 0 75 0 0 258 1 257 224 237 c124 131 225 240 225 243 0 3 -46 5 -102 5 l-103 0 -159 -175 c-88 -96 -160 -175 -162 -175 -1 0 -75 79 -165 175 l-163 175 -94 0 c-72 0 -91 -3 -86 -12z" />
                            <path d="M7060 4839 l83 -90 44 43 c25 24 63 64 85 91 l40 47 -167 0 -167 0 82 -91z" />
                            <path d="M7850 4430 l0 -500 488 2 487 3 0 70 0 70 -413 3 -413 2 3 143 3 142 243 3 242 2 0 60 0 60 -242 2 -243 3 -3 143 -3 142 391 0 390 0 0 75 0 75 -465 0 -465 0 0 -500z" />
                            <path d="M9050 4431 l0 -501 333 0 c345 0 430 7 502 41 52 25 107 78 131 128 22 44 31 170 15 221 -15 50 -62 114 -111 149 l-39 28 26 24 c84 77 85 247 2 330 -69 69 -90 72 -496 77 l-363 4 0 -501z m731 311 c54 -61 28 -160 -48 -181 -21 -6 -113 -11 -205 -11 l-168 0 0 -75 0 -75 208 0 c231 0 251 -5 292 -72 29 -47 27 -134 -3 -179 -44 -66 -59 -69 -369 -69 l-278 0 0 350 0 351 271 -3 271 -3 29 -33z" />
                            <path d="M10350 4430 l0 -500 80 0 80 0 0 500 0 500 -80 0 -80 0 0 -500z" />
                            <path d="M5751 4877 c-14 -23 -138 -244 -278 -492 l-253 -450 280 -3 c154 -1 406 -1 559 0 l279 3 -273 483 c-150 266 -277 488 -282 493 -4 4 -19 -11 -32 -34z" />
                            <path d="M5548 2213 l-3 -1308 -2497 -3 -2498 -2 0 -225 0 -225 2720 0 2720 0 0 1535 0 1535 -220 0 -220 0 -2 -1307z" />
                            <path d="M8542 3430 c-77 -16 -144 -62 -264 -180 -107 -105 -118 -120 -133 -174 -44 -150 35 -288 194 -341 25 -8 102 -22 171 -30 69 -8 157 -20 195 -25 232 -36 315 74 286 377 -18 190 -70 294 -175 347 -49 25 -71 30 -144 32 -48 2 -106 -1 -130 -6z m227 -76 c105 -53 151 -151 159 -341 4 -117 3 -125 -22 -176 -48 -99 -106 -112 -349 -82 -217 27 -291 62 -340 160 -55 113 -10 224 150 360 96 82 151 104 264 104 73 1 93 -3 138 -25z" />
                            <path d="M8493 3289 c-106 -41 -213 -172 -213 -261 0 -136 130 -207 381 -209 97 -1 134 17 167 81 40 80 27 225 -29 312 -59 92 -185 123 -306 77z m183 -30 c41 -15 93 -70 111 -117 25 -65 24 -176 -1 -218 -32 -53 -70 -69 -164 -67 -184 4 -302 74 -302 180 0 43 46 129 88 163 86 70 181 92 268 59z" />
                            <path d="M8503 3160 c-38 -19 -73 -67 -73 -99 0 -56 70 -101 155 -101 74 0 105 28 105 95 0 37 -6 52 -33 81 -42 46 -94 54 -154 24z" />
                            <path d="M6610 3060 l0 -180 178 0 c125 0 182 4 190 12 7 7 12 44 12 95 l0 83 -95 0 c-95 0 -95 0 -95 -25 0 -24 2 -25 65 -25 l65 0 0 -45 0 -45 -130 0 -131 0 3 128 3 127 125 0 125 0 3 -28 c3 -24 7 -28 30 -25 23 3 27 8 30 39 5 65 -6 69 -204 69 l-174 0 0 -180z" />
                            <path d="M7470 3061 l0 -181 30 0 30 0 0 155 0 155 68 0 c81 0 112 -17 112 -60 0 -37 -32 -60 -82 -60 -34 0 -38 -3 -38 -24 0 -20 6 -25 32 -28 28 -3 37 -12 71 -70 34 -60 42 -68 68 -68 16 0 29 3 29 6 0 4 -18 38 -39 75 -37 64 -39 70 -22 81 56 40 54 142 -2 178 -15 10 -61 16 -139 18 l-118 4 0 -181z" />
                            <path d="M9360 3079 c0 -91 4 -169 10 -180 10 -18 23 -19 173 -19 114 0 167 4 175 12 8 8 12 63 12 180 l0 168 -25 0 -25 0 0 -136 c0 -74 -5 -144 -10 -155 -10 -17 -22 -19 -118 -19 -71 0 -112 4 -120 12 -8 8 -12 57 -12 155 l0 143 -30 0 -30 0 0 -161z" />
                            <path d="M10210 3060 l0 -180 30 0 30 0 0 155 0 155 71 0 c88 0 109 -10 109 -54 0 -42 -18 -57 -75 -64 -39 -4 -45 -8 -45 -28 0 -21 5 -24 34 -24 116 0 180 71 141 154 -26 54 -58 66 -184 66 l-111 0 0 -180z" />
                          </g>
                        </svg>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <table className="table3col">
                      <thead>
                        <tr>
                          <th colSpan="3">اطلاعات کالا جهت تولید</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* <tr>
                          <td><strong>دسته بندی</strong></td>
                          <td><strong>برند</strong></td>
                          <td><strong>کد پارکت</strong></td>
                        </tr> */}
                        <tr>
                          <td>{data.task.product.category.name}</td>
                          <td style={{ fontSize: 24, fontWeight: 'bold' }}>
                            {data.task.product.brand.name}
                          </td>
                          <td className="en">
                            <span style={{ fontSize: 24, fontWeight: 'bold' }}>
                              {data.task.product.name}
                            </span>
                            <br />
                            (کد: {data.task.product.extraCode})
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="row">
                    <table className="table4col">
                      <thead>
                        <tr>
                          <th colSpan="4">اطلاعات کالای پرس شده</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="big-cell">
                            <strong>تعداد کل پرس شده در این شیفت</strong>
                          </td>
                          <td
                            className="big-cell"
                            style={{ fontSize: 24, fontWeight: 'bold' }}>
                            {
                              data.productItems.filter(
                                el => el.taskOperationProductType === 1
                              )[0].subQuantity
                            }
                          </td>
                          <td className="big-cell">
                            <strong>تعداد در پالت</strong>
                          </td>
                          <td className="big-cell" />
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="row">
                    <table className="table3col">
                      <thead>
                        <tr>
                          <th colSpan="3">اطلاعات کالا مواد اولیه</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <strong>دسته بندی</strong>
                          </td>
                          <td>
                            <strong>برند</strong>
                          </td>
                          <td>
                            <strong>نام کالا</strong>
                          </td>
                        </tr>
                        {data.productItems &&
                          data.productItems.map((item, index) =>
                            item.product.category.id !== 6 &&
                            item.taskOperationProductType === 0 ? (
                              <tr key={'input-product-' + index}>
                                <td>
                                  <strong>{item.product.category.name}</strong>
                                </td>
                                <td>{item.product.brand.name}</td>
                                <td>{item.product.name}</td>
                              </tr>
                            ) : (
                              ''
                            )
                          )}
                      </tbody>
                    </table>
                  </div>

                  {data.salesManagerDescription ? (
                    <div className="row">
                      <fieldset className="fieldset">
                        <legend>توضیحات مسئول برنامه‌ریزی تولید</legend>
                        <pre className="pre">
                          {data.salesManagerDescription}
                        </pre>
                      </fieldset>
                    </div>
                  ) : (
                    ''
                  )}

                  {data.unitShiftManagerDescription ? (
                    <div className="row">
                      <fieldset className="fieldset">
                        <legend>توضیحات سرشیفت پرس</legend>
                        <pre className="pre">
                          {data.unitShiftManagerDescription}
                        </pre>
                      </fieldset>
                    </div>
                  ) : (
                    ''
                  )}

                  {/* <div className="row">
                    <table className="table5col">
                      <thead>
                        <tr>
                          <th><strong>شماره پرس</strong></th>
                          <th><strong>شیفت</strong></th>
                          <th><strong>سرشیفت</strong></th>
                          <th><strong>مسئول پرس</strong></th>
                          <th><strong>کنترل کیفی</strong></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{data.unitName}</td>
                          <td>{data.shift}</td>
                          <td>{data.personnels.filter(el => el.taskOperationPersonnelType === 1)[0] ? data.personnels.filter(el => el.taskOperationPersonnelType === 1)[0].fullName : ''}</td>
                          <td>{data.personnels.filter(el => el.taskOperationPersonnelType === 2)[0] ? data.personnels.filter(el => el.taskOperationPersonnelType === 2)[0].fullName : ''}</td>
                          <td>{data.personnels.filter(el => el.taskOperationPersonnelType === 4)[0] ? data.personnels.filter(el => el.taskOperationPersonnelType === 4)[0].fullName : ''}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table className="table1col">
                      <thead>
                        <tr>
                          <th>اپراتور های پرس</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            {data.personnels && data.personnels.filter(el => el.taskOperationPersonnelType === 0).map((item, index) => (
                              <span className="personnel" key={'operator-' + index}>{item.fullName}</span>
                            ))}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div style={{ marginTop: 5 }}>چاپ توسط: {props.user ? props.user.fullName : ''}</div>
                  </div> */}
                </div>
              )}
            </section>
          </page>

          {loading ? <Loading /> : ''}
        </DialogContent>
      </Dialog>
    </React.Fragment>
  )
}

function mapStateToProps(state) {
  const { authentication } = state
  const { user } = authentication
  return {
    user
  }
}

const connectedPrint = connect(mapStateToProps)(Print)
export { connectedPrint as Print }
